import axios, { AxiosError } from "axios";
import { useMutation, UseMutationOptions } from "react-query";

import { getApiFormattedDate } from "../utils/dateFormatter";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { MODIFY_CALL_API } from "./constants";

interface ModifyCallResponse {
  0: string[];
  dueDate: string;
  callAmount: number;
}

interface PostModifyCallProps {
  dueDate: string | Date;
  callAmount?: number;
}

export const usePostModifyCall = (
  eventId: string,
  options: UseMutationOptions<
    ModifyCallResponse,
    AxiosError<{ errorDescription: string }>,
    {}
  >
) => {
  const modifyCallUrl = `${getAppConfigSetting("apiUrl")}${MODIFY_CALL_API(
    eventId
  )}`;

  const postModifyCall = async ({
    dueDate,
    callAmount,
  }: PostModifyCallProps) => {
    const { data } = await axios(modifyCallUrl, {
      method: "put",
      withCredentials: true,
      data: {
        dueDate: getApiFormattedDate(dueDate),
        amount: callAmount,
      },
    });
    return { ...data, dueDate, callAmount };
  };

  return useMutation(postModifyCall, {
    retry: false,
    ...options,
  });
};
